import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';

const STATS = [
  { value: '594', label: '在观察话题' },
  { value: '2.8万', label: '累计网友讨论' },
  { value: '每日', label: '09:00 更新热榜' },
];

export default function Hero() {
  const [keyword, setKeyword] = useState('');
  const navigate = useNavigate();

  const handleSearch = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/topics?q=${encodeURIComponent(q)}` : '/topics');
  };

  return (
    <section className="relative w-full min-h-[560px] md:min-h-[680px] flex items-center justify-center">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20editorial%20collage%20of%20glowing%20speech%20bubbles%20and%20crowd%20silhouettes%20over%20a%20warm%20terracotta%20and%20amber%20gradient%20sky%2C%20stylized%20artistic%20illustration%2C%20soft%20grain%2C%20dramatic%20lighting&width=1800&height=1100&seq=hero-gossip-main&orientation=landscape"
          alt="网络热议话题的抽象插画背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/75"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-10 pt-24 pb-16 md:pt-28 md:pb-24 text-center">
        <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/15 backdrop-blur border border-background-50/25 text-background-50 text-xs md:text-sm mb-6">
          <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse-soft"></span>
          实时围观中 · 今日新增 37 个热议话题
        </span>

        <h1 className="font-heading text-3xl md:text-6xl font-black text-background-50 leading-tight tracking-wide max-w-4xl mx-auto">
          网报吃瓜：一眼看清网友热议与大众态度
        </h1>

        <p className="mt-5 md:mt-7 text-sm md:text-lg text-background-100/85 max-w-2xl mx-auto leading-relaxed">
          汇集网报吃瓜评论、网友热议与不同立场，用温度榜和立场分布帮你快速抓住讨论方向，遇到事件不再一头雾水。
        </p>

        <form onSubmit={handleSearch} className="mt-8 md:mt-10 max-w-xl mx-auto w-full">
          <div className="flex items-center gap-2 bg-background-50 rounded-full p-1.5 pl-5">
            <i className="ri-search-line text-lg text-foreground-500"></i>
            <label htmlFor="hero-search" className="sr-only">
              搜索热议话题
            </label>
            <input
              id="hero-search"
              name="keyword"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索你正在围观的话题，如「电影口碑」"
              className="flex-1 h-11 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
            />
            <button
              type="submit"
              className="h-11 px-5 md:px-7 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              看热议
            </button>
          </div>
        </form>

        <div className="mt-10 md:mt-14 grid grid-cols-3 gap-4 md:gap-10 max-w-2xl mx-auto">
          {STATS.map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="font-heading text-xl md:text-3xl font-bold text-accent-400">{stat.value}</p>
              <p className="mt-1 text-xs md:text-sm text-background-100/70">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}